import { isVaultTemplateRef } from '@onefootprint/core';

// Returns null when either side is a vault template; the backend re-checks the pair at runtime.
const orderedPair = (a: unknown, b: unknown): { min: number; max: number } | null => {
  if (a === undefined || a === '' || a === null) return null;
  if (b === undefined || b === '' || b === null) return null;
  if (isVaultTemplateRef(a) || isVaultTemplateRef(b)) return null;
  const min = Number(a);
  const max = Number(b);
  if (Number.isNaN(min) || Number.isNaN(max)) return null;
  return { min, max };
};

export default orderedPair;
